
document.addEventListener('DOMContentLoaded', function(){

/* Otwarcie wszystkich zakładek filtrów na desktop */
const filterTabs = document.querySelectorAll("#FacetsWrapperDesktop details");
if(filterTabs){
document.querySelectorAll("#FacetsWrapperDesktop details").forEach( el => {
    el.setAttribute('open', '')
})
}

/*
*
*   --------------------------------------
*   Otwieranie panelu z filtrami na mobile
*   --------------------------------------
*/
jQuery(document).ready(function($){
$('.display-options').click(function(){
if(window.innerWidth < 600){
    $('.mobile-facets__open-wrapper').click()
}
})
})



})

